export class VacationCreatedNotificationConfig {
  public enabled = false;
  public recipient_ids: string[] = [];

  static createInstance(
    data: Partial<VacationCreatedNotificationConfig> | null | undefined,
  ): VacationCreatedNotificationConfig {
    const c = new VacationCreatedNotificationConfig();
    if (!data) return c;
    c.enabled = data.enabled ?? false;
    c.recipient_ids = Array.isArray(data.recipient_ids) ? data.recipient_ids.map(String) : [];
    return c;
  }
}

export class EvaCompanyPlanningNotificationConfig {
  public vacation_created = new VacationCreatedNotificationConfig();

  static createInstance(
    data: Partial<EvaCompanyPlanningNotificationConfig> | null | undefined,
  ): EvaCompanyPlanningNotificationConfig {
    const c = new EvaCompanyPlanningNotificationConfig();
    if (!data) return c;
    c.vacation_created = VacationCreatedNotificationConfig.createInstance(data.vacation_created);
    return c;
  }
}
